import { Link } from 'react-router';

export const NotFoundPage = () => (
  <div className="mx-auto w-full max-w-2xl px-6 py-16">
    <h1 className="text-2xl">Ez az oldal nem található</h1>
    <p className="mt-4 text-ink-soft">
      Elképzelhető, hogy elírás történt a címben, vagy az oldal időközben megszűnt.
    </p>
    <Link
      to="/"
      className="mt-8 inline-flex min-h-12 items-center rounded-md border-2 border-navy px-6 font-semibold text-navy no-underline hover:bg-navy hover:text-cream"
    >
      Vissza a főoldalra
    </Link>
  </div>
);
